import { Component, Input } from '@angular/core';
import { ChangePasswordModalComponent } from '../change-password-modal/change-password-modal.component';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent {
  @Input() id: number;
  @Input() type: number;

  constructor(
    private dialog: MatDialog
  ) { }

  openChangePasswordModal(): void {
    this.dialog.open(ChangePasswordModalComponent, {
      width: '600px',
      disableClose: true,
      data: {
        ID: this.id,
        userType: this.type
      }
    });
  }
}
